import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonAlternative from 'sd-ui/dist/commonjs/components/ButtonAlternative/ButtonAlternative';
import {
  MIN_SCALE_FOR_SIBLING_EXTRA_TEXT,
  BREAKPOINT_MOBILE_IN_PX,
  SIDE_PANEL_WIDTH,
} from '../../constants';
import { trackNavigationClick } from '../../utils/trackers/adobe';

export default function SiblingButton({
  data,
  scale,
  stayFitToWidth,
  icon,
  siblingType,
  iconPlacement,
  clientWidth,
  sidePanelOpen,
  id,
  adobeContentType,
  navigationNameEventData,
}) {
  if (!stayFitToWidth && scale < 0.3) {
    return null;
  }

  const scaleTooSmall = (scale < MIN_SCALE_FOR_SIBLING_EXTRA_TEXT && !stayFitToWidth)
    || (
      stayFitToWidth
      && clientWidth < (BREAKPOINT_MOBILE_IN_PX + SIDE_PANEL_WIDTH)
      && sidePanelOpen
    )
    || (
      stayFitToWidth
      && clientWidth < 547
    );

  const boldTextClassNames = classnames({
    bold: !scaleTooSmall,
  });

  const scaleTooSmallForAnyText = stayFitToWidth && sidePanelOpen && clientWidth < 713;
  const labelClassNames = classnames('label', {
    'u-display-none': scaleTooSmallForAnyText,
  });
  const label = (
    <span className={labelClassNames}>
      <span className={boldTextClassNames}>
        {siblingType}
      </span>
      &nbsp;PDF
    </span>
  );

  const { pii } = data;
  let href;
  let disabled = false;
  if (pii) {
    href = `${window.config.SDBaseUrl}/sdfe/reader/pii/${pii}/pdf`;
  } else {
    disabled = true;
  }

  return (
    <ButtonAlternative
      iconPlacement={iconPlacement}
      id={id}
      href={href}
      icon={icon}
      className={classnames('button-alternative-tertiary', { disabled })}
      disabled={disabled}
      target="_blank"
      onClick={() => trackNavigationClick(adobeContentType, navigationNameEventData)}
    >
      {label}
    </ButtonAlternative>
  );
}

SiblingButton.propTypes = {
  data: PropTypes.shape({
    pii: PropTypes.string,
  }),
  id: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  iconPlacement: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  stayFitToWidth: PropTypes.bool,
  siblingType: PropTypes.string.isRequired,
  clientWidth: PropTypes.number,
  sidePanelOpen: PropTypes.bool,
  navigationNameEventData: PropTypes.string.isRequired,
  adobeContentType: PropTypes.string,
};

SiblingButton.defaultProps = {
  data: {},
  stayFitToWidth: false,
  sidePanelOpen: false,
  clientWidth: 1000,
  adobeContentType: undefined,
};
